/**
 * Configuración del carrusel de imágenes/anuncios/videos
 * 
 * Cada elemento debe tener:
 * - id: Identificador único
 * - type: 'image' o 'video'
 * - image: Ruta del archivo (imágenes en assets/images/ads/, videos en assets/videos/ads/)
 * - url: URL a la que se redirige al hacer clic (opcional)
 * - alt: Texto alternativo para accesibilidad
 * - duration: Duración en pantalla en milisegundos (opcional, si no se especifica usa carouselSettings.interval)
 */

// Importar imágenes
import ad1 from '../assets/images/ads/ad1.jpg';
import ad2 from '../assets/images/ads/ad2.jpg';
import ad3 from '../assets/images/ads/ad3.jpeg';
import ad4 from '../assets/images/ads/ad4.jpg';

// Importar videos (descomentar cuando tengas el video)
// import videoCliente from '../assets/videos/ads/cliente-video.mp4';

export const carouselItems = [
    {
        id: 1,
        type: 'image',
        image: ad1,
        duration: 3000, //3 segundos
        url: 'https://www.facebook.com/carlosgutrod',
        alt: 'Carlos Gutrod'
    },
    {
        id: 2,
        type: 'image',
        image: ad2,
        duration: 10000, // 10 segundos
        url: 'https://www.facebook.com/anzurgenilmotorsl',
        alt: 'Anzur Genil Motor'
    },
    {
        id: 3,
        type: 'image',
        image: ad3,
        duration: 10000, // 10 segundos
        url: 'https://www.mercadillocasariche.es',
        alt: 'Macromercadillo Casariche'
    },
    {
        id: 4,
        type: 'image',
        image: ad4,
        duration: 10000, // 10 segundos
        url: 'https://www.facebook.com/OficinaFarmaciaVelasco',
        alt: 'Farmacia Velasco'
    },
        // Ejemplo de video (descomentar cuando tengas el video)
    // {
    //     id: 3,
    //     type: 'video',
    //     image: videoCliente,
    //     duration: 20000, // 20 segundos (ajusta según la duración real del video)
    //     url: 'https://www.cliente.com',
    //     alt: 'Video promocional cliente'
    // },
];

// Configuración del carrusel
export const carouselSettings = {
    // Intervalo por defecto si el item no especifica duration (en milisegundos)
    interval: 10000,
    // Duración de la transición fade in/out en milisegundos
    transitionDuration: 800, // Aumentado para transiciones más suaves
};
